import { EMPTY_PRODUCT_DETAILS } from 'lane-shared/domains/billingPayments/constants';

export const EMPTY_TABLE_ROW_RPODUCT_DETAILS = {
  ...EMPTY_PRODUCT_DETAILS,
  tableRowId: '',
  tableProductType: '',
};
